import React  from 'react';
import { withRouter } from 'react-router-dom';
import { InvoiceType } from 'common/constants';

import {
    Table, TableBody,    
} from '@material-ui/core';

function InvoicesTable(props) {
    function rowClicked(invoice) {
        const invoiceId = InvoiceType.getNumberForInvoice(props.invoiceType,invoice);
        const customerId = invoice.customerId;
        let urlPart = InvoiceType.editInvoicesPart(props.invoiceType);
        
        props.history.push({ pathname: `/customer/${customerId}/${urlPart}/${invoiceId}` });
    }
      
    return (
        <Table className='invoice-table'>
            {props.generateTableHeader()}
            <TableBody>
                {props.generateTableRows((index) => rowClicked(index))}
            </TableBody>
        </Table>
    )
}

export default withRouter(InvoicesTable);